export class CustomerLoanParameters {

    static instance = {
        controller: ['$scope', CustomerLoanParameters],
        template: require('./customerLoanParameters.html'),
        bindings: {
            loanInfo: '<'
        }
    };

    constructor($scope) {
        this.$scope = $scope;
    }

    $onInit = () => {
        this.$scope.loanInfo = this.loanInfo;
    }
}